module.exports = __webpack_public_path__ + "static/img/main_point_img04.31afd6f6.svg";